"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var StyledButtonGroup_1 = require("./StyledButtonGroup");
var ButtonGroup = function (_a) {
    var children = _a.children, activeToggleIndex = _a.activeToggleIndex, rest = tslib_1.__rest(_a, ["children", "activeToggleIndex"]);
    return (react_1.default.createElement(StyledButtonGroup_1.StyledButtonGroup, { activeToggleIndex: activeToggleIndex }, react_1.default.Children.map(children, function (button, index) {
        return react_1.default.cloneElement(button, tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, rest), button.props), (activeToggleIndex !== undefined && { 'aria-pressed': index === activeToggleIndex })));
    })));
};
exports.ButtonGroup = ButtonGroup;
//# sourceMappingURL=ButtonGroup.js.map